import { User } from '../../../Models/avyna/user.model';
import { HomeDestination } from '../Interfaces/home-destination.interface';

export function isHomeDestinationVisible(destination: HomeDestination, user: User | null): boolean {
  if (user === null) return false;
  if (destination.entitlement !== undefined && !user.hasEntitlement(destination.entitlement)) return false;
  if (destination.permission !== undefined && !user.hasPermission(destination.permission)) return false;
  return destination.alsoRequires === undefined || user.hasPermission(destination.alsoRequires);
}
